__turbopack_context__.v({
  "cardsView": "TabView-module__byRdga__cardsView",
  "dx-scrollable": "TabView-module__byRdga__dx-scrollable",
  "selectedTags": "TabView-module__byRdga__selectedTags",
  "sidebar": "TabView-module__byRdga__sidebar",
  "tagWrapper": "TabView-module__byRdga__tagWrapper",
  "view": "TabView-module__byRdga__view",
  "wrapper": "TabView-module__byRdga__wrapper",
});
